import React from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";

import RichText from "../Prismic/RichText";
import SubHero from "wonderbly-components/lib/SubHero";

const HeroIV = (props) => (
  <SubHero
    containerClass="container-guttered"
    heroHeight={props.heroHeight}
    backgroundImage={
      isEmpty(props.backgroundImage) ? null : props.backgroundImage
    }
    content={<RichText fields={props.content} color={props.contentColor} />}
    contentVerticalAlign={props.contentVerticalAlign}
    contentHorizontalAlign={props.contentHorizontalAlign}
    cta={props.cta}
    ctaLink={props.ctaLink}
    ctaColor={props.ctaColor}
    ctaStyle={props.ctaStyle}
  />
);

HeroIV.propTypes = {
  containerClass: PropTypes.string,
  heroHeight: PropTypes.string,
  backgroundImage: PropTypes.object,
  content: PropTypes.array.isRequired,
  contentColor: PropTypes.string,
  cta: PropTypes.string,
  ctaLink: PropTypes.string,
  contentVerticalAlign: PropTypes.string,
  contentHorizontalAlign: PropTypes.string,
  ctaColor: PropTypes.string,
  ctaStyle: PropTypes.string,
};

export default HeroIV;
